<script setup lang="ts">
import type { Audience } from '@/types/types'

defineProps<{
  audiences: Audience[]
}>()

const defaultMerchantSegmentId = defineModel<number | null>('defaultMerchantSegmentId')

const emit = defineEmits(['audience-created'])

const { t } = useI18n()

const handleSelectAudience = (audienceId: number | null) => {
  defaultMerchantSegmentId.value = audienceId
}

const handleAudienceCreated = () => {
  emit('audience-created')
}
</script>

<template>
  <div class="text-left">
    <h2 class="text-lg font-medium">{{ t('pages.import.importPage.organize.title') }}</h2>
    <div class="mb-6 text-sm text-muted-foreground">
      {{ t('pages.import.importPage.organize.subtitle') }}
    </div>

    <div class="mb-2 text-sm">
      {{ t('pages.import.importPage.organize.inputLabel') }}
    </div>

    <DropdownAudience
      :model-value="defaultMerchantSegmentId"
      :audiences="audiences"
      type="static"
      clearable
      creation-allowed
      :placeholder="t('global.multiselect.audiences.placeholderCreateAllowed')"
      :filter-placeholder="t('global.multiselect.audiences.filterPlaceholderCreateAllowed')"
      :default-empty-message="t('global.multiselect.audiences.noLists')"
      @update:model-value="handleSelectAudience"
      @audience-created="handleAudienceCreated"
    />
  </div>
</template>
